import {useRef} from "react";
import useCloseDialogOnOutsideClick from "@Features/dialog/hooks/useCloseDialogOnOutsideClick";
import DialogConfigType from "@Features/dialog/types/DialogConfig.type";
import {dialogDefaultConfig} from "@Features/dialog/constants/dialogDefaultConfig";

export default function useDialog(attr?: DialogConfigType) {
    const {
        isClosedClickOutside,
        isFullScreen,
        onClose,
    } = {...dialogDefaultConfig, ...attr}

    const dialogRef = useRef<HTMLDialogElement>(null)

    const closeModal = () => {
        dialogRef?.current?.close()
        onClose()
    }

    const openModal = () => {
        if (isFullScreen) {
            dialogRef?.current?.showModal()
        } else {
            dialogRef?.current.show()
        }
    }

    useCloseDialogOnOutsideClick(dialogRef, closeModal, isClosedClickOutside)

    return {
        dialogRef,
        closeModal,
        openModal,
    }
}